import React from 'react';
import 'components/page-offline/page-offline.scss';
import { Button, Result } from 'antd';
import { DisconnectOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslator } from 'tools/view-hooks/translator-hook';

const PageOffline: React.FC = () => {
    const { translate } = useTranslator();
    const navigate = useNavigate();

    // Sin entradas previas, navigate(-1) es un no-op silencioso: el botón
    // quedaría muerto sin ninguna señal. Mejor no ofrecerlo.
    const canGoBack = window.history.length > 1;

    return (
        <div className={'page-offline'}>
            <Result
                icon={<DisconnectOutlined className={'page-offline-icon'} />}
                title={translate({ key: 'common-errors.offline-title' })}
                subTitle={translate({ key: 'common-errors.offline-sub' })}
                extra={
                    canGoBack ? (
                        <Button type={'primary'} className={'page-offline-button'} onClick={() => navigate(-1)}>
                            {translate({ key: 'common-errors.offline-retry' })}
                        </Button>
                    ) : undefined
                }
            />
        </div>
    );
};

export default PageOffline;
